import React from 'react';
import { DataContentProps } from '../content/types';
import { Loading } from '../design/loading/Loading';

function DummyContent({ data, isLoading }: DataContentProps) {
  let groups = 0;
  let rows = 0;
  if (data) {
    const groupedSets = data.getGroupedSets();
    groups = groupedSets.length;
    groupedSets.forEach(set => {
      rows += set.data.length;
    });
  }
  return (
    <div className="relative py-14 rounded bg-brand-lightest px-4">
      <Loading isActive={isLoading} withIndicator />
      <p>
        I'm a core dummy data element with data containing {groups} result sets, with around {rows} items of data
      </p>
    </div>
  );
}

export { DummyContent };
